var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "edit_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#edit_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#87858B",
  d: "m12.867 5.949-2.834-2.8.934-.934a1.28 1.28 0 0 1 .941-.383c.373 0 .686.128.942.383l.933.934c.256.255.39.564.4.925.011.36-.11.67-.366.925l-.95.95Zm-.967.983-7.067 7.067H2v-2.834L9.067 4.1 11.9 6.932Z"
}))));
export default SvgEdit;